import ApplicationForm from '@/components/forms/ApplicationForm';

export default function VJMultimedia() {
  return (
    <ApplicationForm
      applicationType="vj-multimedia"
      title="VJ & Multimedia"
      description="Light up the night! We're seeking VJs, projection artists, lighting designers, 
        and multimedia creators to transform our stages into immersive visual experiences."
      showPortfolio={true}
      showExperience={true}
      showRequirements={true}
      showInsurance={false}
      showCertificates={false}
    />
  );
}
